// extracted by mini-css-extract-plugin
export var arrow = "_cg-1";
export var content = "_cg-0";
export var highlighted = "_cg-2";